import React from "react";
import commonClose from '../../../assets/img/commonClose.png';
import HeaderLangKr from '../../../assets/img/HeaderLangKr.png';
import HeaderLangUs from '../../../assets/img/HeaderLangUs.png';
import HeaderLangCn from '../../../assets/img/HeaderLangCn.png';
import HeaderLangJp from '../../../assets/img/HeaderLangJp.png';
import HeaderLangId from '../../../assets/img/HeaderLangId.png';

/*
 * UserLangModal
 * - 리뉴얼 헤더 전용 언어선택 모달.
 * - 기존 SelectLangModal 의 출력 위치(화면 중앙) / 국기 아이콘 / 5개국을 그대로 유지하고
 *   라이트/다크 모드만 추가 지원(uh- 변수 기반).
 */
const LANGS = [
    {code: "ko", label: "한국어", flag: HeaderLangKr},
    {code: "en", label: "English", flag: HeaderLangUs},
    {code: "ja", label: "日本語", flag: HeaderLangJp},
    {code: "zh", label: "中国語", flag: HeaderLangCn},
    {code: "id", label: "bahasaIndo", flag: HeaderLangId},
];

function UserLangModal({theme, selectLangFalseFn, handleSelectLangChange}) {
    return (
        <div className="uh-langmodal-overlay" data-theme={theme} onClick={selectLangFalseFn}>
            <div className="uh-langmodal" onClick={(e) => e.stopPropagation()}>
                <div className="uh-langmodal-head">
                    <p>Language</p>
                    <button className="uh-langmodal-close" onClick={selectLangFalseFn}>
                        <img src={commonClose} alt="close"/>
                    </button>
                </div>
                <div className="uh-langmodal-body">
                    {LANGS.map((l) => (
                        <div key={l.code} className="uh-langmodal-item" onClick={() => handleSelectLangChange(l.code)}>
                            <img src={l.flag} alt={l.code}/>
                            <span>{l.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default UserLangModal;
